import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/financial/maintenanceFinancialsReportActions'
import { Button, Form, AutoComplete, Input, Icon, Spin } from 'antd'
import _ from 'lodash'
import { convertToOption } from '../../../util'
import ListItems from '../../../components/reports/financial/maintenance-financials-report/ListItems'
import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const propTypes = {}
const FormItem = Form.Item

class MaintenanceFinancialsContainer extends Component {
  constructor(props) {
    super(props)

    // get job list
    this.props.maintenanceFinancialsReportGetOrganizationList({})
  }

  applyFilter = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.maintenanceFinancialsReportGetFullReport({ filters: values })
    })
  }

  handleOrganizationSearch = _.debounce(value => {
    this.props.maintenanceFinancialsReportGetOrganizationList({
      filters: {
        name: value
      }
    })
  }, 500)

  printReport = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      const params = _.omit(values, 'date_range')

      const qs = queryString.stringify(params)
      const url = `${API_BASE}/api/reports/financial/maintenance-financials-report/print?${qs}`
      window.open(url, '_blank')
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    const organizationListData = _.get(
      this.props,
      'maintenanceFinancialsReportActions.organizationList.data'
    )

    const loadingOrganizationList = _.get(
      this.props,
      'maintenanceFinancialsReportActions.loadingOrganizationList'
    )

    const loadingFullReport = _.get(
      this.props,
      'maintenanceFinancialsReportActions.loadingFullReport'
    )
    const fullReport = _.get(this.props, 'maintenanceFinancialsReportActions.fullReport.data')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Maintenance Financials</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-6">
              <div className="row">
                <div className="col-6">
                  <Spin spinning={loadingOrganizationList}>
                    <FormItem label="Company">
                      {getFieldDecorator('organization_id', {})(
                        <AutoComplete
                          onChange={this.handleOrganizationSearch}
                          dataSource={convertToOption(organizationListData)}
                          filterOption={(inputValue, option) =>
                            option.props.children
                              .toUpperCase()
                              .indexOf(inputValue.toUpperCase()) !== -1
                          }
                          placeholder="Search for a Company"
                        >
                          <Input
                            suffix={<Icon type="search" className="certain-category-icon" />}
                          />
                        </AutoComplete>
                      )}
                    </FormItem>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
          <Button type="primary" onClick={() => this.applyFilter()}>
            Submit
          </Button>
        </Form>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <ListItems fullReport={fullReport} loadingFullReport={loadingFullReport} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ maintenanceFinancialsReportActions, authentication }, ownProps) => ({
  maintenanceFinancialsReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

MaintenanceFinancialsContainer.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(MaintenanceFinancialsContainer))
)



// WEBPACK FOOTER //
// ./src/containers/reports/financial/MaintenanceFinancialsReportContainer.js